import { i18n } from '@/common/utils/i18n'

export const shopPadInfoStatusList = [
  {
    value: 0,
    icon: 'warn', // rich ui icon name 'richic-' + icon
    content: i18n.gettext('未完善')
  },
  {
    value: 1,
    icon: 'right',
    content: i18n.gettext('已完善')
  }
]
const shopPadInfoStatusMap = {}
const shopPadInfoIconMap = {}
shopPadInfoStatusList.forEach(item => {
  shopPadInfoStatusMap[item.value] = item.content
  item.icon && (shopPadInfoIconMap[item.value] = item.icon)
})
export const padInfo = {
  label: i18n.gettext('门店PAD信息'),
  type: 'visitSelProp',
  prop: 'padInfoPerfect',
  props: {
    placeholder: i18n.gettext('设置'),
    map: shopPadInfoStatusMap,
    iconMap: shopPadInfoIconMap
  },
  rules: ['required', ['requireValue', i18n.gettext('门店PAD信息'), 1]],
  checkVisible: (data) => {
    // 扩展信息 5
    return data.visitResult && data.visitResult.value.includes(15)
  }
}

let padDisabled = false
const padInfoConfig = [
  {
    label: i18n.gettext('是否需要pad'),
    type: 'rich-radio-group',
    prop: 'isNeedPad',
    props: {
      horizontal: true,
      options: [
        {
          value: 1,
          label: i18n.gettext('需要'),
          disabled: false
        },
        {
          value: 2,
          label: i18n.gettext('不需要'),
          disabled: false
        }
      ]
    },
    rules: [['required', i18n.gettext('是否需要pad')]]
  },
  {
    label: i18n.gettext('IMEI'),
    type: 'sugSelect',
    prop: 'padIMEI',
    props: {
      type: 'padIMEI',
      sugName: 'SugSelImei', // sug 弹窗 组件名
      placeholder: i18n.gettext('请输入'),
      disabled: false
    },
    // rules: [['required', i18n.gettext('IMEI')]],
    checkVisible: (data) => {
      return data.isNeedPad === 1
    }
  },
  {
    label: i18n.gettext('PAD领取人'),
    type: 'sugSelect',
    prop: 'padTransactor',
    props: {
      type: 'padTransactor',
      sugName: 'SugSelUser', // sug 弹窗 组件名
      placeholder: i18n.gettext('姓名'),
      disabled: false
    },
    // rules: [['required', i18n.gettext('PAD领取人')]],
    checkVisible: (data) => {
      return data.isNeedPad === 1
    }
  }
]

export const hasPadPropList = padInfoConfig.map(item => {
  return item.prop
})

const disabledPropList = [
  'isNeedPad',
  'padIMEI',
  'padTransactor'
]
function configDisabled (config, disabled) {
  if (padDisabled === disabled) {
    return config
  }
  padDisabled = disabled
  config.forEach(item => {
    if (disabledPropList.includes(item.prop) && item.props) {
      if (item.props.options) {
        item.props.options.forEach(opt => {
          opt.disabled = padDisabled
        })
      } else {
        item.props.disabled = padDisabled
      }
    }
  })
  return config
}
export function getPadInfoConfig (disabled = false) {
  return configDisabled(padInfoConfig, disabled)
}
